export enum EPanoramaState {
  Loaded,
  None,
}
